import type LazyModuleConfig from '../types/LazyModuleConfig';

const loadedImports: Record<string, boolean> = {};

let config: LazyModuleConfig = {
    markImportAsLoaded: (ids: string[]) => {
        for (const id of ids) {
            loadedImports[id] = true;
        }
    },
    isImportLoaded: (id: string) => loadedImports[id],
    logUsage: () => {},
    logError: () => {},
    logGreyError: async () => {},
    trace: () => {},
    // We can not import featureFlags in LazyImport because of dependency issue. Passing it as parameter.
    isFeatureEnabled: () => false,
};

export function getConfig(): LazyModuleConfig {
    return config;
}

export function setConfig(newConfig: LazyModuleConfig): void {
    // Copy over any imports that have already loaded
    newConfig.markImportAsLoaded(Object.keys(loadedImports));

    // Replace the old config
    config = newConfig;
}

/**
 * Replaces only the provided fields of the current config, keeping the default
 * import tracking. Intended for threads (e.g. web workers) that do not use the
 * observable import tracking provided by owa-bundling.
 */
export function updateConfig(partialConfig: Partial<LazyModuleConfig>): void {
    setConfig({ ...config, ...partialConfig });
}

export function stopAutoGovernForBundling(): void {
    config.govern = undefined;
}
